const Systems ="krasa" 

export default Systems;
